export default __webpack_public_path__ + "static/employment-scam-038382cbc911848325af392e7de6bc3a.webp";